export default () => ({
  total: 0,
  digital_certificate: null,
})
